<template>
  <layout>
    <template slot="header"> {{ isNew ? 'Add' : 'Edit' }} app </template>

    <template>
      <div class="mx-4">
        <subheader>General info</subheader>
        <v-text-field
          v-model="localEntity.name"
          label="Name *"
          :rules="[rules.required]"
          :error="!!errors.name"
          :error-messages="errors.name"
          clearable
        ></v-text-field>
        <v-text-field
          v-if="isNew"
          v-model="localEntity.password"
          :rules="[rules.required]"
          :error="!!errors.password"
          :error-messages="errors.password"
          label="New password *"
          type="password"
          clearable
        ></v-text-field>
        <v-text-field
          v-if="isNew"
          v-model="localEntity.repeatPassword"
          :rules="[rules.required]"
          :error="!!errors.repeatPassword"
          :error-messages="errors.repeatPassword"
          type="password"
          label="Repeat password *"
          clearable
        ></v-text-field>
        <div class="d-flex align-center mx-0">
          <div style="font-size: 16px">Show hidden</div>
          <v-spacer />
          <v-switch
            data-test-switch="hidden"
            class="ma-0 py-3"
            hide-details
            v-model="localEntity.hidden"
          ></v-switch>
        </div>
        <div class="d-flex align-center mx-0">
          <div style="font-size: 16px">Enabled</div>
          <v-spacer />
          <v-switch
            data-test-switch="enabled"
            class="ma-0 py-3"
            hide-details
            v-model="localEntity.enabled"
          ></v-switch>
        </div>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.group"
          multiple
          label="Groups"
          item-text="name"
          item-value="id"
          :items="groups"
          chips
          class="ma-0"
        ></v-select>
        <subheader>Meta info</subheader>
        <v-text-field
          v-model="localEntity.lognName"
          label="Long name"
          clearable
        ></v-text-field>
        <v-text-field
          v-model="localEntity.contact"
          label="Contact"
          clearable
        ></v-text-field>
        <v-text-field
          v-model="localEntity.email"
          :rules="[rules.email]"
          :error="!!errors.email"
          :error-messages="errors.email"
          label="Email"
          clearable
        ></v-text-field>
        <v-text-field
          v-model="localEntity.phoneNumber"
          label="Phonenumber"
          clearable
        ></v-text-field>
        <v-text-field
          v-model="localEntity.secondId"
          label="Second ID"
          clearable
        ></v-text-field>
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          v-model="localEntity.tag"
          multiple
          label="Tags"
          item-text="name"
          item-value="id"
          :items="tags"
          chips
          class="ma-0"
        ></v-select>
        <div v-if="!isNew">
          <subheader>Photo</subheader>
          <div class="user_photo pa-5">
            <v-img
              src="@/assets/fallback.png"
              contain
              height="100"
              width="100%"
            ></v-img>
            <div class="upload" @click="upload('photo')">
              <input
                @input="filePick('photo')"
                type="file"
                ref="photo"
                style="display: none"
              />
              <v-img
                src="@/assets/upload.png"
                contain
                height="16"
                width="24"
              ></v-img>
            </div>
          </div>
          <subheader>Icon</subheader>
          <div class="user_photo pa-5">
            <v-img
              src="@/assets/fallback.png"
              contain
              height="100"
              width="100%"
            ></v-img>
            <div class="upload" @click="upload('icon')">
              <input
                @input="filePick('icon')"
                type="file"
                ref="icon"
                style="display: none"
              />
              <v-img
                src="@/assets/upload.png"
                contain
                height="16"
                width="24"
              ></v-img>
            </div>
          </div>
        </div>
        <subheader>Variables</subheader>
        <v-textarea
          v-model="localEntity.vars"
          no-resize
          rows="1"
          auto-grow
        ></v-textarea>
        <subheader>Description</subheader>
        <v-textarea
          v-model="localEntity.description"
          no-resize
          rows="1"
          auto-grow
        ></v-textarea>
      </div>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text @click.stop="close">
        cancel
      </v-btn>
      <v-btn color="primary" text @click.stop="save">
        <template v-if="isNew">add</template>
        <template v-else>save</template>
      </v-btn>
    </template>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '@/layouts/LayoutPopup';
export default {
  name: 'editApp',
  props: {
    entity: {
      type: [Object],
      required: true
    }
  },
  components: {
    Layout
  },
  data: () => ({
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
    localEntity: {},
    errors: {}
  }),
  computed: {
    tags() {
      return [
        {
          id: 'tags1',
          name: 'Tags 1'
        },
        {
          id: 'tags2',
          name: 'Tags 2'
        }
      ];
    },
    groups() {
      return [
        {
          id: 'group1',
          name: 'Group 1'
        },
        {
          id: 'group2',
          name: 'Group 2'
        }
      ];
    },
    isNew() {
      return !this.localEntity.id;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    save() {
      this.$emit('save', { ...this.localEntity });
    },
    upload(field) {
      this.$refs[field].click();
    }
  },
  created() {
    this.localEntity = { ...this.entity };
  }
};
</script>

<style lang="scss" scoped>
.user_photo {
  position: relative;
  background-color: #dbdbdb;
  background-position: center;
}
.upload {
  position: absolute;
  top: 8px;
  right: 16px;
  padding: 12px 8px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.44);
}
</style>
